import React from "react";

import { TextButton } from "../../../common/Typography";
import LoginOtpResendCooldownTimer from "./LoginOtpResendCooldownTimer";

function OtpResendRow({
  translate,
  disabled,
  onResend,
  secondsRemaining
}) {
  return (
    <p className={"text-sm line-height-100 font-medium text-black-5 mb-8"}>
      {translate("auth_otp-page_resend-prompt")}{" "}
      <strong className={"font-bold text-black"}>
        <TextButton className={"ml-2"} disabled={disabled} onClick={onResend}>
          {translate("auth_otp-page_resend-link")}
        </TextButton>
        <LoginOtpResendCooldownTimer secondsRemaining={secondsRemaining} />
      </strong>
    </p>
  );
}

export default OtpResendRow;
